import React from "react";

const Footer = () => {

    return (
      <footer id="main-footer" className="bg-dark text-white pt-3 p-1">
        <div className="container">
          <div className="row">
            <div className="col">
              <p className="text-center">
                Copyright &copy;
                <span id="yearFooter">{new Date().getFullYear()}&nbsp;</span>
                GOVI
              </p>
            </div>
          </div>
        </div>
      </footer>
    );
  }


export default Footer;
